import React, { Component } from "react";
import {
  Row,
  Col,
  UncontrolledAlert,
  Card,
  Button,
  CardHeader,
  CardBody,
} from "reactstrap";
import { MdAdd } from "react-icons/md";
import Formsy from "formsy-react";
import { Spinner } from "../../Shared";
import CategoryDropDown from "../../Shared/CategoryDropDown";
import { TextInput } from "../../Shared/Forms";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { tourMessages } from "../../../_constants/tutorialmessages/ManualMessages";
class InterestForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      canSubmit: false,
      run: false,
      stepIndex: 0,
      steps: [
        {
          target: tourMessages.adminInterestForm.target,
          content: (
            <div>
              <p>{tourMessages.adminInterestForm.title}</p>
              <p
                style={{ color: "blue", fontStyle: "italic", fontSize: "10px" }}
              >
                {tourMessages.adminInterestForm.content}
              </p>
            </div>
          ),
          placement: "left",
          locale: { skip: "SKIP" , close: 'Next'},
        },
        tourMessages.default,
      ],
    };

    this.defaultInput = React.createRef();
    this.focusTextInput = this.focusTextInput.bind(this);
  }
  focusTextInput() {
    this.defaultInput.current.reset();
  }

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  handleSubmit = data => {
    let requestBody = { ...data, categoryId: data.categoryId.id };
    this.props.submitAction(requestBody);
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.submitSucessful) {
      this.resetForm();
    }
    if (nextProps.showNextJoyRide) {
      this.setState({ run: true });
      this.props.setNextJoyRide();
    }
  }

  resetForm = () => {
    this.refs.interestForm.reset();
    if (this.categoryRef) {
      this.categoryRef.categories.changeValue(null);
    }
  };

  ClearAll = () => {
    this.props.reset();
    this.resetForm();
  };
  handleJoyrideCallback = data => {
    const { action, index, status, type } = data;

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
    } else if ([STATUS.CANCEL, STATUS.CANCEL].includes(status)) {
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      if ([STATUS.SKIPPED].includes(status)) {
        this.setState({ run: false });
      } else {
        this.props.startJoyRideAtDataTable();
      }
    }
  };
  render() {
    const { canSubmit, run, steps, stepIndex } = this.state;
    const { submitting, error, hasParams, selectedRow } = this.props;
    const hasValue = selectedRow && hasParams;
    let selectedCategoryObject = null;
    if (selectedRow) {
      selectedCategoryObject = {
        id: selectedRow.categoryId,
        name: selectedRow.categoryName,
      };
    }

    return (
      <div>
        <Joyride
          steps={steps}
          scrollToFirstStep
          showProgress
          showSkipButton
          styles={{
            options: {
              width: 200,
              height: 60,
              zIndex: 1000,
            },
          }}
          callback={this.handleJoyrideCallback}
          run={run}
          stepIndex={stepIndex}
        />
        <Row>
          <Col>
            <Card>
              <CardHeader>{hasParams ? "Edit" : "Create"} Interest</CardHeader>
              <CardBody>
                {error ? (
                  <UncontrolledAlert color="danger">
                    {error.message}
                  </UncontrolledAlert>
                ) : null}
                <Formsy
                  ref="interestForm"
                  onValidSubmit={this.handleSubmit}
                  onValid={this.enableButton}
                  onInvalid={this.disableButton}
                  noValidate
                >
                  <TextInput
                    name="name"
                    value={
                      hasValue && selectedRow.name ? selectedRow.name : null
                    }
                    required
                    disabled={submitting}
                    title="Interest"
                    validations={{
                      minLength: 3,
                      maxLength: 50,
                    }}
                    validationErrors={{
                      minLength: "Minimum of 3 characters allowed",
                      maxLength: "Maximum of 50 characters allowed",
                    }}
                  />
                  <TextInput
                    name="description"
                    required
                    value={
                      hasValue && selectedRow.description
                        ? selectedRow.description
                        : null
                    }
                    disabled={submitting}
                    title="Description"
                    validations={{
                      minLength: 5,
                    }}
                    validationErrors={{
                      minLength: "Minimum of 5 characters allowed",
                      maxLength: "Maximum of 50 characters allowed",
                    }}
                  />
                  <CategoryDropDown
                    value={selectedCategoryObject}
                    innerRef={c => {
                      this.categoryRef = c;
                    }}
                    isRequired={true}
                    disabled={submitting}
                    name="categoryId"
                  />
                  <Button
                    type="submit"
                    color="primary"
                    disabled={!canSubmit || submitting}
                    className="joyride6"
                  >
                    {submitting ? (
                      <Spinner size="sm" />
                    ) : (
                      <span>
                        {hasParams ? "Update" : "Create"} <MdAdd size={20} />
                      </span>
                    )}
                  </Button>{" "}
                  {hasParams ? (
                    <Button
                      type="button"
                      outline
                      color="primary"
                      onClick={() => this.ClearAll()}
                    >
                      Reset
                    </Button>
                  ) : null}
                </Formsy>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default InterestForm;
